import moment from "moment";

export const defaultDateTime = (value) =>
  value ? moment(value).format("DD/MM/YYYY - HH:mm น.") : value;

export const defaultDate = (value) =>
  value ? moment(value).format("DD/MM/YYYY") : value;

export const defaultTime = (value) =>
  value ? moment(value).format("HH:mm น.") : value;

export const customDate = (value, format) =>
  value ? moment(value).format(format) : value;

export const isTimeExceeded = (timeString) => {
  if (!timeString) return false;

  const specifiedTime = moment(timeString, "HH:mm:ss");

  return moment().isAfter(specifiedTime);
}